<template>
  <div class="retry-report">
    <div class="content">
      <p class="highlight">
        Todas as OS’s foram transferidas.
      </p>
      <p>Clique abaixo para visualizar o relatório de amostras.</p>
    </div>

    <div>
      <button
        class="btn-primary button"
        @click="getTotalSamplesFromTransferring()"
      >
        VISUALIZAR RELATÓRIO
      </button>
      <br>
      <button
        class="btn btn-nonenary button"
        @click="pushToPrint()"
      >
        VISUALIZAR AMOSTRAS E LOTES
      </button>
      <br>
      <button
        class="btn btn-primary button"
        @click="redirectToDocRequiredPage()"
      >
        ANEXAR DOCUMENTOS OBRIGATÓRIOS
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'RetryReport',
  props: {
    pushToPrint: Function
  },
  methods: {
    ...mapActions(['getTotalSamplesFromTransferring'])
  }
}
</script>

<style lang="scss">
.retry-report {
  .md-dialog-content {
    padding: 0 20px 34px;
  }

  .content {
    p {
      text-align: start;
      padding: 1px 0 23px;
      font-family: Roboto, sans-serif;
      font-style: normal;
      color: #444;
      line-height: 19px;
      font-size: 15px;
      text-align: start;
      font-weight: 400;
    }

    .highlight {
      font-weight: 900;
    }
  }

  .button {
    width: 100%;
    margin-top: 10px;
    font-family: Roboto, sans-serif;
    border-radius: 3px;
    font-weight: 500;
    letter-spacing: 0.4px;
  }

  .btn-primary {
    margin-top: 0;
  }
}

.transfer-modal.modals .md-dialog {
  min-height: auto;
}
</style>
